import type { Preview } from './master/contract.js';

type PreviewLine = Preview['gains'][number];
export type PreviewAnswer = Pick<Preview, 'words'> & Partial<Omit<Preview, 'words' | 'gains' | 'loses'>> & {
  gains?: Array<Omit<PreviewLine, 'items'> & { items?: string[] }>;
  loses?: Array<Omit<PreviewLine, 'items'> & { items?: string[] }>;
};

/** Older preview answers can omit the lists; readers always receive the whole shape. */
export function wholePreview(answer: PreviewAnswer): Preview {
  return {
    ...answer,
    gains: (answer.gains ?? []).map(line => ({ ...line, items: line.items ?? [] })),
    loses: (answer.loses ?? []).map(line => ({ ...line, items: line.items ?? [] })),
    othersChange: answer.othersChange ?? [],
    staysSame: answer.staysSame ?? [],
    affected: answer.affected ?? [],
    takeBack: answer.takeBack ?? false,
    // An answer without its lists measured nothing, so it lists nothing (REQ-2026-10-16-40, F6).
    ...(answer.listed === false || !answer.gains || !answer.loses ? { listed: false as const } : {}),
  };
}
